import React from 'react';

import { EventBus } from '@vtblife/event-bus';
import { useRouter, SearchRoute, SearchMapRoute } from '@search/offer-search-routes/src';
import { useClGeoRootRegion } from './useClGeoRootRegion';

type EventBusUserRegionData = {
    userRegionId?: number;
    userRegionIdNarrow?: number;
    userRegionName?: string;
};

export function useClGeoRootRegionUrlSwitch() {
    const router = useRouter();
    const rootRegions = useClGeoRootRegion();

    React.useEffect(() => {
        const eventBus = EventBus.getInstance();
        const subscription = eventBus.subscribe<'userRegion:change', EventBusUserRegionData>(
            'userRegion:change',
            event => {
                const data = event.data;
                let supportedRegion: undefined | number;

                if (data.userRegionId) supportedRegion = rootRegions.byId(data.userRegionId)?.id;
                if (! supportedRegion && data.userRegionIdNarrow) {
                    supportedRegion = rootRegions.byId(data.userRegionIdNarrow)?.id;
                }
                if (! supportedRegion) return;

                const searchRoute = router.route(SearchRoute);
                const searchMapRoute = router.route(SearchMapRoute);
                let route = undefined as SearchRoute | SearchMapRoute | undefined;

                if (searchRoute.paramsSafe()) route = searchRoute;
                else if (searchMapRoute.paramsSafe()) route = searchMapRoute;

                if (! route) return;

                const currentParams = new URLSearchParams(router.location.search);

                const utmParams: { [key: string]: string } = {};

                currentParams.forEach((value, key) => {
                    if (key.startsWith('utm_')) {
                        utmParams[key] = value;
                    }
                });

                route.push({
                    ...route.params(),
                    region: supportedRegion,
                    ...utmParams
                });
            }
        );

        return () => {
            subscription.unsubscribe();
        };
    }, [ rootRegions ]);
}
